import { render, staticRenderFns } from "./Visitors.vue?vue&type=template&id=19e1f5cb&"
import script from "./Visitors.vue?vue&type=script&lang=js&"
export * from "./Visitors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/pawan/Vizmo/Max/dashboard-old/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
